import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EmptyWarehouseModel, IWarehouseModel } from "./WarehousesApp";
import { IDataDisplayerPagination } from "../../components/DataDisplayer/DataDisplayer";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { ISearchParam } from "../BaseApp";

interface IWarehousesState {
    warehouses: IWarehouseModel[],
    selectedWarehouses: IWarehouseModel[],
    searchParams: ISearchParam[],
    loading: boolean,
    pagination: IDataDisplayerPagination,
    search?: string,
    savedWarehouses: IWarehouseModel[],
}

const initialState: IWarehousesState = {
    warehouses: [],
    selectedWarehouses: [],
    searchParams: [],
    loading: false,
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    },
    savedWarehouses: []
}

const warehousesSlice = createSlice({
    name: "warehouses",
    initialState,
    reducers: {
        updateAllWarehouses: (state: IWarehousesState, action: PayloadAction<Array<IWarehouseModel>>) => {
            state.warehouses = action.payload
        },
        addNewWarehouse: (state: IWarehousesState, action: PayloadAction<IWarehouseModel>) => {
            let warehouses = state.warehouses

            if (warehouses.filter(warehouse => warehouse.id === action.payload.id).length === 0){
                state.warehouses.push(action.payload)
            }

        },
        addNewSavedWarehouse: (state, action: PayloadAction<IWarehouseModel>) => {
            if (!state.savedWarehouses.some(w => w.id === action.payload.id)) {
                state.savedWarehouses.push(action.payload);
            }
        },
        deleteWarehouse: (state: IWarehousesState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let warehouses = state.warehouses

            warehouses = warehouses.filter(item => item.id !== payload.id)

            state.warehouses = warehouses

        },
        updateWarehouse: (state: IWarehousesState, action: PayloadAction<IWarehouseModel>) => {
            let warehouses = state.warehouses
            
            if (warehouses && warehouses.length > 0){
                warehouses.map((warehouse) => {
                    if (warehouse.id === action.payload.id){

                        const locationIndex = warehouses.findIndex(warehouse => warehouse.id === action.payload.id)
                        warehouses[locationIndex] = action.payload

                    }
                })
            }

            state.warehouses = warehouses

        },
        updateWarehousesLoadingStatus: (state: IWarehousesState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updateWarehousesPagination: (state: IWarehousesState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updateWarehousesSearch: (state: IWarehousesState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        setSelectedWarehouses: (state: IWarehousesState, action: PayloadAction<IWarehouseModel[]>) => {
            state.selectedWarehouses = action.payload
        },
        updateWarehousesSearchParams: (state: IWarehousesState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
    }
})

/**
 * Return all warehouses
 */
export const useReturnAllWarehouses = () => useSelector((state: RootState) => state.warehouses.warehouses)

/**
 * Retrun single warehouse
 */
export const useReturnSingleWarehouse = (id: number) => {
    const warehouses = useReturnAllWarehouses()

    let warehouse: IWarehouseModel = EmptyWarehouseModel

    if (warehouses.length > 0){
        warehouses.map((singleWarehouse) => {
            if (singleWarehouse.id === id){
                warehouse = singleWarehouse
            }
        })
    }

    return warehouse

}

export const returnSingleWarehouse = (id: number, warehouses: IWarehouseModel[]) => {

    let warehouse: IWarehouseModel = EmptyWarehouseModel

    if (warehouses.length > 0){
        warehouses.map((singleWarehouse) => {
            if (singleWarehouse.id === id){
                warehouse = singleWarehouse
            }
        })
    }

    return warehouse

}

export const returnSavedSingleWarehouse = (id: number, warehouses: IWarehouseModel[]) => {

    if (warehouses.length > 0){
        warehouses.map((singleWarehouse) => {
            if (singleWarehouse.id === id){
                return singleWarehouse
            }
        })
    }

    return null

}

/**
 * Return warehouses loading status
 */
export const useReturnWarehousesLoadingStatus = () => useSelector((state: RootState) => state.warehouses.loading)

/**
 * Return warehouses pagination
 */
export const useReturnWarehousesPagination = () => useSelector((state: RootState) => state.warehouses.pagination)

/**
 * Return warehouses search
 */
export const useReturnWarehousesSearch = () => useSelector((state: RootState) => state.warehouses.search)

/**
 * Return warehouses search params
 */
export const useReturnWarehousesSearchParams = () => useSelector((state: RootState) => state.warehouses.searchParams)

/**
 * Return warehouses search params
 */
export const useReturSelectedWarehouses = () => useSelector((state: RootState) => state.warehouses.selectedWarehouses)

export const { updateAllWarehouses, addNewWarehouse, deleteWarehouse, updateWarehouse, updateWarehousesLoadingStatus, updateWarehousesPagination, updateWarehousesSearch, setSelectedWarehouses, updateWarehousesSearchParams, addNewSavedWarehouse } = warehousesSlice.actions
export default warehousesSlice.reducer